/**
 * 数字 字母等处理函数
 */

/** 数字ascii码 */
const CODE_NUMBER = [48, 57]
/** 大写字母ascii码 */
const CODE_LETTER_UP = [65, 90]
/** 小写字母ascii码 */
const CODE_LETTER_LOW = [97, 122]
/** 十六进制用到的小写字母ascii码 */
const CODE_LETTER_HEX = [97, 102]



/**
 * 取len长度的随机数字和大小写字母组合的字符串
 * @param len 
 */
export function getRandomString(len = 16) {
  const arr_info = [CODE_NUMBER, CODE_LETTER_UP, CODE_LETTER_LOW]
  return _getRandomSringByArray(arr_info, len)
}

/**
 * 通过二维数组取随机字符
 * @param arr_info 
 * @param len 
 */
 function _getRandomSringByArray(arr_info, len) {
  let ret = ''
  for (let i = 0; i < len; ++i) {
    const interval = arr_info[Math.floor(Math.random() * arr_info.length)]
    ret += _getRandomSringByInterval(interval[0], interval[1])
  }
  return ret
}

/**
 * 
 * @param min 
 * @param max 
 */
function _getRandomSringByInterval(min, max) {
  return String.fromCharCode(min + Math.floor(Math.random() * (max - min + 1)))
}